import { useMutation } from '@tanstack/react-query';

import { post } from '~lib/api/client';

type Data = {
  email: string;
  feedback: string;
};

const url = '/api/service/feedback';
function usePostFeedbackMutation() {
  return useMutation((data: Data) => post(url, { ...data }));
}

export default usePostFeedbackMutation;
